import React, { useEffect, useState } from "react";
import Webcam from "react-webcam";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Skeleton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import visitorImage from "../Images/vps.svg";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useDispatch, useSelector } from "react-redux";
import "../Css/visitorsStyle.css";
import TypeformReplica from "./EnterDetailsFlow";
import {
  GetVisitorReasonActions,
  GetVisitorsAction,
  GetVMExtraSettingConfigRequestAction,
  UpdateVisitorsAction,
} from "../../../../store/Employee/Visitors/Action";
import * as faceapi from "face-api.js";
import { getUserId, getDomain, getUserData, s3Client } from "../../Base/helper/baseFunctions";
import { v4 as uuidv4 } from "uuid";
import { toast, ToastContainer } from "react-toastify";
import thnxImg from "../Images/confetti.gif";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import SuccessVisitorDialog from "./SuccessDialog";
import CheckIcon from "@mui/icons-material/Check";
import "react-toastify/dist/ReactToastify.css";
import { Logout } from "@mui/icons-material";
import ArrowBackButton from "../../Base/views/ArrowBackButton";
import { signOut } from "../../SignIn/helper/SigninHelper";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { GetVMMultipleOrgConfigurationHelper, GetVMOrgTypeHelper } from "../../VisitorSettings/helper/OrgType/OrgTypeHelper";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { Html5Qrcode } from "html5-qrcode";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import { DeleteEmailTokenHelper, GetEmailTokenHelper } from "../../Ancillary/EmailToken/helper/EmailTokenHelper";
import { upsertVMVisitorManagementTransactionsrHelper } from "../helper/PreRegistrationHelper";
import { GetVisitorManagementRegionHelper } from "../../VisitorSettings/helper/Region/RegionHelper";
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import history from "../../../../history";
import HomeIcon from '@mui/icons-material/Home';
import { GetEmployeesAndExternalUsersHelper } from "../../Employee/helper/EmployeeHelper";
import {GetWhatsappConfigAction} from "../../../../store/Ancillary/WhatsappConfig/Action";


const VisitorManagement = () => {
  const initialValue = {
    contactno: "",
    name: "",
    employee_id: "",
    visitors_management_reasons_pk: "",
    visitor_image_url: "",
    image_url: "",
    visitor_image_descriptor: "",
    entry_type: "",
    id_proof: "", 
    vehicle_no: "",
    multiple_org_configuration_fk: ""
  };
  const location = useLocation();
  const navigationState = location?.state || null;
  const [retry, setRetry] = useState(false);
  const [visitorFormData, setVisitorFormData] = useState(initialValue);
  const [mode, setMode] = useState(null); // "check-in" or "check-out"
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [checkInSuccess, setCheckInSuccess] = useState(false);
  const [checkOutSuccess, setCheckOutSuccess] = useState(false);
  const [faceRecogMessage, setFaceRecogMessage] = useState("Detecting face...");
  const [checkOutSecondOption, setCheckOutSecondOption] = useState(false);
  const [visitorCheckOutNumber, setVisitorCheckOutNumber] = useState("");
  /////
  const [visitorTypePopup, setVisitorTypePopup] = useState({
    type: "",
    open: false
  })
  const [qrInOutPopup, setQrInOutPopup] = useState({
    type: "",
    open: false
  })
  const [qrMode, setQrMode] = useState(false);
  const [cameraFacing, setCameraFacing] = useState("environment"); 
  const scannerRef = React.useRef(null);
  const qrScanInProgress = React.useRef(false);
  const [qrData, setQrData] = useState("");
  ///
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const isNewFaceModel = atsModuleData?.find((item) => item.module_name === "New Face Model");
  const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");

  const dispatch = useDispatch();
  const { userId, domain, company, region_fk, whatsflow } = useParams();
  const user_id = userId ? atob(userId) : getUserId();
  const Domain = domain ? atob(domain) : getDomain();
  const Company = company ? atob(company) : getUserData().company_full_name;
  const [regionFk, setRegionFk] = useState(region_fk ? atob(region_fk) : "");
  const isWhatsappFlow = whatsflow === "true" ? whatsflow : whatsAppFlow;
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [visitorReasonData, setVisitorReasonData] = useState({
    load: true,
    values: [],
  });

  const [visitorOrgData, setVisitorOrgData] = useState({
    load: true,
    values: [],
  });
  const [isSingleOrg, setIsSingleOrg] = useState(true);
  const [employeesOptions, setEmployeesOptions] = useState([]);

  const { visitors_data, visitor_reasons, visitorLoading } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
  const handleEmployees = () => {
    employeesOptions &&
      setEmployeesData({ load: false, values: employeesOptions });
  };
  const handleVisitorReasons = () => {
    visitor_reasons &&
      setVisitorReasonData({ load: false, values: visitor_reasons });
  };
  const handleOrg = () => {
    GetVMOrgTypeHelper({domain_name: Domain}).then((res) => {
      if(res?.data?.statuscode === 200) {
        setIsSingleOrg(res?.data?.data?.[0]?.is_vm_org_type_single)
        if (!res?.data?.data?.[0]?.is_vm_org_type_single) {
          GetVMMultipleOrgConfigurationHelper({domain_name: Domain}).then((res) => {
            if(res?.data?.statuscode === 200){
              setVisitorOrgData({load: false, values: res?.data?.data})
            }
          })
        } else {
          setVisitorOrgData({load: false, values: []})
        }
      }
    })
  }
  useEffect(() => {
    GetEmployeesAndExternalUsersHelper({ domain : Domain }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeesData({ load: false, values: res?.data?.data });
        setEmployeesOptions(res?.data?.data);
      } else {
        setEmployeesData({ load: false, values: [] });
      }
    })
    dispatch(GetVisitorReasonActions({domain : Domain}));
    dispatch(GetVisitorsAction({domain : Domain, userId : user_id}));
    dispatch(GetVMExtraSettingConfigRequestAction({domain: Domain}));
    dispatch(GetWhatsappConfigAction({domain: Domain}));
    handleOrg();
    if (!region_fk) {
      GetVisitorManagementRegionHelper().then(res => {
            if (res?.data?.statuscode === 200) {
                const regionData = res?.data?.data || [];
                const defaultRegion = regionData?.filter(el => el.is_default);
                setRegionFk(defaultRegion?.[0]?.visitors_management_regions_pk || "");
            }
        })
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const loadModels = async () => {
      const MODEL_URL = "/models";
      await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
      await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
      await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
    };
    loadModels();
  }, []);
  const webcamRef = React.useRef(null);
  const handleModeSelection = (selectedMode) => {
    setMode(selectedMode);
    setIsCameraActive(true);
  };
  const handleCheckIn = () => {
    setVisitorFormData(initialValue);
    setQrInOutPopup({ type: "", open: false });
    setVisitorTypePopup({ type: "", open: true });
  };
  const handleQRInOut = () => {
    setVisitorTypePopup({ type: "", open: false });
    setQrInOutPopup({ type: "", open: true });
  };
  const handleVisitorTypeSelect = (type) => {
    setVisitorTypePopup({ type, open: false });
    if (type === "WalkIn") {
      setMode("Check In");
      setIsCameraActive(true);
    } else if (type === "Guest") {
      setQrMode(true);
    }
  };
  const handleQRSelect = (type) => {
    setQrInOutPopup({ type, open: false });
    setQrMode(true);
  }
  const captureImage = async () => {
    if (!webcamRef.current) return;

    setIsLoading(true);
    const webImage = webcamRef.current.getScreenshot();

    if (webImage) {
      try {
        let descriptor = "";
        let img_filename = "";
        let img_b64string = webImage;

        const ext = img_b64string?.split(";")[0]?.split(":")[1]?.split("/")[1];
        img_filename = `${Domain}/VisitorsManagement/Visitors/${uuidv4()}.${ext}`;

        const imgElement = new Image();
        imgElement.src = webImage;
        await new Promise((resolve, reject) => {
          imgElement.onload = resolve;
          imgElement.onerror = reject;
        });

        const detections = await faceapi
          .detectSingleFace(imgElement, new faceapi.TinyFaceDetectorOptions())
          .withFaceLandmarks()
          .withFaceDescriptor();
        if (detections) {
          const descriptorArray = detections.descriptor
            ? Array.from(detections.descriptor)
            : [];
          descriptor =
            descriptorArray.length > 0 ? JSON.stringify(descriptorArray) : "";
          setVisitorFormData((prev) => ({
            ...prev,
            visitor_image_url: img_filename,
            image_url: img_b64string,
            visitor_image_descriptor: descriptor,
          }));
          setCapturedImage(webImage);
          setIsLoading(false);
          setIsCameraActive(false);
        } else {
          toast.error("Face detection failed. Please try again.");
          setIsLoading(false);
          return;
        }
      } catch (error) {
        console.error("Image capture error:", error);
        toast.error("Something went wrong while processing the image.");
        setIsLoading(false);
      }
    }
  };
  const isValidDescriptor = (descriptor) => {
    try {
      const parsedDescriptor = JSON.parse(descriptor);

      if (
        Array.isArray(parsedDescriptor) &&
        parsedDescriptor.every((item) => typeof item === "number")
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Invalid descriptor format:", error);
      return false;
    }
  };
  const [checkOutVisitorImage, setCheckOutVisitorImage] = useState("");
  const [checkOutInfo, setCheckOutInfo] = useState({ url: "", checkOutId: "" });
  const [user, setUser] = useState(null);
  const getImageSignedUrl = async (currentData) => {
    setUser(currentData);
    let filename = currentData?.visitor_image_url;
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      setCheckOutVisitorImage(url);
      setCheckOutInfo({
        url: url,
        checkOutId: currentData?.visitors_management_pk,
      });
      return url;
    } catch (err) {}
  };
  const stopScanner = async () => {
    if (scannerRef.current) {
      try {
        const state = scannerRef.current.getState();

        if (state === 2) { 
          await scannerRef.current.stop();
        }

        await scannerRef.current.clear();
        scannerRef.current = null;
      } catch (err) {
        console.log("Safe stop error:", err);
      }
    }
  };
  const handleReset = async () => {
    await stopScanner();

    setIsCameraActive(false);
    setVisitorCheckOutNumber("");
    setCheckOutSecondOption(false);
    setQrMode(false);
    setQrData("");
    setMode(null);
    setIsLoading(false);
  };
  const handleResetForm = () => {
    setVisitorFormData(initialValue);
    setIsCameraActive(false);
    setCapturedImage(null);
    setMode(null);
    setVisitorTypePopup({ type: "", open: false });
    setQrMode(false);

  }
  const markCheckOut = (data) => {
    setIsLoading(true);
    let visitor_id;
    if (data === "second-option" && visitorCheckOutNumber) {
      const findVisitor = visitors_data?.filter(
        (item) =>
          item.visitors_mobile_no === visitorCheckOutNumber &&
          !item.checkout_timestamp
      );
      if (findVisitor?.length > 0) {
        getImageSignedUrl(findVisitor?.[0]);
        visitor_id = findVisitor?.[0]?.visitors_management_pk;
      } else {
        toast.error("Visitor Not Found");
        handleReset();
        return;
      }
    } else {
      visitor_id = data?.visitors_management_pk;
    }
    const getLocalISOTime = () => {
      const now = new Date();
      const offsetInMinutes = now.getTimezoneOffset();
      const localTime = new Date(now.getTime() - offsetInMinutes * 60000);
      return localTime.toISOString().slice(0, -1); 
    };
    const checkout_timestamp = getLocalISOTime();
    dispatch(
      UpdateVisitorsAction(
        {
          visitors_management_pk: +visitor_id,
          domain : Domain, 
          userId : user_id, 
          checkout_timestamp, region_fk : regionFk
        },
        (error, result) => {
          if (!error && result?.data?.statuscode === 200) {
            DeleteEmailTokenHelper({ domain: Domain, token: data?.token_id });
            setCheckOutSecondOption(false);
            setCheckOutSuccess(true);
            setIsLoading(false);
            setTimeout(() => {
              handleReset();
              setCheckOutSuccess(false);
            }, 5000);
          } else {
            handleReset();
            toast.error("Something went wrong");
          }
        }
      )
    );
  };
  const handleCheckOut = async () => {
    setFaceRecogMessage("Detecting face...");

    if (webcamRef.current && webcamRef.current.video.readyState === 4) {
      const video = webcamRef.current.video;
      // Ensure video dimensions are valid
      if (!video.videoWidth || !video.videoHeight) {
        toast.error("Camera feed is not available. Please try again.");
        return;
      }

      try {
        const detections = await faceapi
          .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
          .withFaceLandmarks()
          .withFaceDescriptor();

        if (
          !detections ||
          !detections.detection ||
          !detections.detection.box ||
          Object.values(detections.detection.box).some(
            (value) => value === null
          )
        ) {
          setFaceRecogMessage("No valid face detected.");
          setRetry(!retry);
          return;
        }

        const registeredUsers = visitors_data || [];
        let matchedUser = null;

        // registeredUsers.forEach((user) => {
        for (const user of registeredUsers) {
          if (
            isValidDescriptor(user?.visitor_image_descriptor) &&
            !user?.checkout_timestamp
          ) {
            const userDescriptorArray = new Float32Array(
              JSON.parse(user?.visitor_image_descriptor)
            );
            const detectionDescriptorArray = new Float32Array(
              detections.descriptor
            );

            if (
              userDescriptorArray.length === detectionDescriptorArray.length
            ) {
              const distance = faceapi.euclideanDistance(
                userDescriptorArray,
                detectionDescriptorArray
              );
              if (distance < 0.5) {
                matchedUser = user;
                break;
              }
            }
          }
        }

        if (matchedUser) {
          await getImageSignedUrl(matchedUser);
          await markCheckOut(matchedUser);
        } else {
          setFaceRecogMessage("Visitor is unknown");
          setTimeout(() => {
            setCheckOutSecondOption(true);
            setIsCameraActive(false);
            setFaceRecogMessage("");
          }, 1000);
        }
      } catch (error) {
        console.error("Error during face recognition:", error);
        toast.error("Face recognition failed. Please try again.");
      }
    } else {
      toast.error("Camera feed is not ready. Please try again.");
      setRetry(!retry);
    }
  };
  useEffect(() => {
    if (visitors_data?.length > 0 && mode === "Check Out") {
      const interval = setInterval(() => {
        if (webcamRef.current && webcamRef.current.video.readyState === 4) {
          clearInterval(interval);
          handleCheckOut();
        }
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitors_data, isCameraActive, mode, retry]);
  const isValidPhoneNumber = (phoneNumber) => {
    return /^[0-9]{10}$/.test(phoneNumber);
  };
  const handleSignout = () => {
    dispatch({ type: "USER_LOGOUT" });
    signOut();

  };
  const switchToAttendance = () => {
    let user_id = btoa(`${getUserId()}=common-portal`);
    if(isNewFaceModel) {
      history.push(`/face-attendance-tracker-new-test/${user_id}`);
    } else {
      history.push(`/face-attendance-tracker-new/${user_id}`);
    }
  };
  // QR Scanner //////////////////////////
  const handleQRScan = async (data) => {
    if (qrScanInProgress.current) return;
    const [, domain_name,tokenType] = data?.split("=") || [];
    if (data && Domain === domain_name && (tokenType === "inout-token" || tokenType === "guest-token")) {
      qrScanInProgress.current = true;
      setIsLoading(true);
      try {
        const res = await GetEmailTokenHelper({
          domain: Domain,
          token: data,
        });
        if (res?.data?.statuscode === 200) {
          const getLocalISOTime = () => {
            const now = new Date();
            const offsetInMinutes = now.getTimezoneOffset();
            const localTime = new Date(now.getTime() - offsetInMinutes * 60000);
            return localTime.toISOString().slice(0, -1);
          };
          const checkin_timestamp = getLocalISOTime();

          const resData = res?.data?.data?.[0];
          const resJsonData = resData?.json_data?.[0];
          if (resData?.token) {
            const todayStr = new Date().toLocaleDateString("en-CA");
             if (visitorTypePopup?.type === "Guest" && tokenType === "guest-token") { // add date checker validation for today
              // resJsonData?.booking_date: "2026-05-19"
              const bookingDate = resJsonData?.booking_date;

              if (bookingDate !== todayStr) {
                toast.error("Visitor booking is not valid for today");
                setQrMode(false);
                await stopScanner();
                return;
              }
               setVisitorFormData((prev) => ({
                 ...prev,
                 contactno: resJsonData?.visitors_mobile_no || "",
                 name: resJsonData?.visitors_name || "",
                 employee_id: resJsonData?.employee_id || "",
                 visitors_management_reasons_pk:
                   resJsonData?.visitors_management_reasons_pk || "",
                 multiple_org_configuration_fk: resJsonData?.multiple_org_configuration_fk || "",
                 token: resData?.token
               }));
               setMode("Check In");
               setIsCameraActive(true);
             } else if ((qrInOutPopup?.type === "In" || qrInOutPopup?.type === "Out") && tokenType === "inout-token") {
                // resData?.createdon: "2026-05-20T01:36:49.222Z", // add date checker validation for today
                const createdOn = resData?.createdon;

                const createdDateStr = createdOn
                  ? new Date(createdOn).toLocaleDateString("en-CA")
                  : null;

                if (createdDateStr !== todayStr) {
                  toast.error("QR code is not valid for today");
                  setQrMode(false);
                  await stopScanner();
                  return;
                }
                upsertVMVisitorManagementTransactionsrHelper({
                  domain: Domain,
                  user_id: user_id,
                  visitors_management_fk: resJsonData?.visitors_management_pk,
                  timestamp: checkin_timestamp,
                  type: qrInOutPopup?.type,
                })
             } else {
               toast.error("Invalid QR Code");
             }
              setQrMode(false);
              await stopScanner();
              return;
          }
        }
        toast.error("Invalid QR Code");
      } catch (err) {
        console.error("QR scan error:", err);
        toast.error("Invalid QR Code");
      } finally {
        setIsLoading(false);
        qrScanInProgress.current = false;
      }
    } else {
      toast.error("Invalid QR Code");
    }

  };
  useEffect(() => {
    if (qrMode) {
      const startScanner = async () => {
        const el = document.getElementById("qr-reader");
        if (!el) return;

        const scanner = new Html5Qrcode("qr-reader");
        scannerRef.current = scanner; // store here

        await scanner.start(
          { facingMode: cameraFacing },
          { fps: 10, qrbox: 250 },
          async (decodedText) => {
            if (qrScanInProgress.current) return;
            setQrData(decodedText);
            await handleQRScan(decodedText);
          }
        );
      };

      setTimeout(startScanner, 300);
    }

    return () => {
      stopScanner();
    };
    // eslint-disable-next-line
  }, [qrMode, cameraFacing]);
  return (
    <>
    {navigationState && 
      <Box
          sx={{
          position: "absolute",
          top: "8px",
          left: "15px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          }}
      >
          <ArrowBackButton onClick={() => history.push(`/common-portal`)} iconSize={21} />
      </Box>}
     <Box
        sx={{
          position: "absolute",
          top: "10px",
          right: "35px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          color: "#000",
          "&:hover": {
            color: "#1976d2",
          },
        }}
        onClick={handleSignout}
      >
        <Logout
          sx={{
            fontSize: "24px",
          }}
        />
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Sign Out
        </Typography>
      </Box>
      <Box className="visitor-container">
        <Dialog
          open={visitorTypePopup.open}
          onClose={() => setVisitorTypePopup({ type: "", open: false })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Select Visitor Type</DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, mt: 1 }}>
              <Button
                variant="outlined"
                size="medium"
                fullWidth
                onClick={() => handleVisitorTypeSelect("WalkIn")}
                sx={{
                  borderColor: "#fecb03",
                  color: "black",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: { xs: "16px", md: "18px" },
                  py: 1,
                  minHeight: "50px",
                  backgroundColor: "transparent",
                  '&:hover': {
                    backgroundColor: "#fecb03",
                    color: "black",
                    borderColor: "#fecb03",
                  },
                }}
              >
                WalkIn
              </Button>
              <Button
                variant="outlined"
                size="medium"
                fullWidth
                onClick={() => handleVisitorTypeSelect("Guest")}
                sx={{
                  borderColor: "#fecb03",
                  color: "black",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: { xs: "16px", md: "18px" },
                  py: 1,
                  minHeight: "50px",
                  backgroundColor: "transparent",
                  '&:hover': {
                    backgroundColor: "#fecb03",
                    color: "black",
                    borderColor: "#fecb03",
                  },
                }}
              >
                Have an Invite
              </Button>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setVisitorTypePopup({ type: "", open: false })}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* QR In Out */}
         <Dialog
          open={qrInOutPopup.open}
          onClose={() => setQrInOutPopup({ type: "", open: false })}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Select QR In-Out</DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, mt: 1 }}>
              <Button
                variant="outlined"
                size="medium"
                fullWidth
                onClick={() => handleQRSelect("In")}
                sx={{
                  borderColor: "#fecb03",
                  color: "black",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: { xs: "16px", md: "18px" },
                  py: 1,
                  minHeight: "50px",
                  backgroundColor: "transparent",
                  '&:hover': {
                    backgroundColor: "#fecb03",
                    color: "black",
                    borderColor: "#fecb03",
                  },
                }}
              >
                QR In
              </Button>
              <Button
                variant="outlined"
                size="medium"
                fullWidth
                onClick={() => handleQRSelect("Out")}
                sx={{
                  borderColor: "#fecb03",
                  color: "black",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: { xs: "16px", md: "18px" },
                  py: 1,
                  minHeight: "50px",
                  backgroundColor: "transparent",
                  '&:hover': {
                    backgroundColor: "#fecb03",
                    color: "black",
                    borderColor: "#fecb03",
                  },
                }}
              >
                QR Out
              </Button>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setQrInOutPopup({ type: "", open: false })}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {!isCameraActive &&
          !capturedImage &&
          !checkOutSecondOption &&
          !checkOutSuccess && !qrMode && (
            <>
              <Box className="visitors-content">
                <Typography
                  variant="h3"
                  sx={{ fontWeight: "bold" }}
                  className="visitors-title"
                >
                  Welcome to Meepl
                </Typography>
                <Box className="visitors-image-container-tab">
                  <img
                    src={visitorImage}
                    alt="Visitors Management"
                    className="visitors-image"
                  />
                </Box>
                <Box className="visitors-button-group">
                  <Box
                    sx={{
                      backgroundColor: "#fecb03",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      padding: { xs: "8px", sm: "14px", md: "10px" },
                      borderRadius: "10px",
                      flex: 1,
                      whiteSpace: "nowrap",
                      height: { xs: "50px", sm: "80px", md: "60px" },
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer",
                      },
                      "&:active": {
                        transform: "translateY(0px)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                    // onClick={() => handleModeSelection("Check In")}
                    onClick={handleCheckIn}
                  >
                    <LoginIcon
                      sx={{ fontSize: { xs: "20px", sm: "36px", md: "30px" } }}
                    />
                    <Typography
                      variant="button"
                      sx={{
                        fontSize: { xs: "14px", sm: "24px", md: "20px" },
                        fontWeight: "bold",
                      }}
                    >
                      Check-In
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "black",
                      color: "#fecb03",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      padding: { xs: "8px", sm: "14px", md: "10px" },
                      borderRadius: "10px",
                      flex: 1,
                      whiteSpace: "nowrap",
                      height: { xs: "50px", sm: "80px", md: "60px" },
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer",
                      },
                      "&:active": {
                        transform: "translateY(0px)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                    onClick={() => handleModeSelection("Check Out")}
                  >
                    <LogoutIcon
                      sx={{ fontSize: { xs: "20px", sm: "36px", md: "30px" } }}
                    />
                    <Typography
                      variant="button"
                      sx={{
                        fontSize: { xs: "14px", sm: "24px", md: "20px" },
                        fontWeight: "bold",
                      }}
                    >
                      Check-Out
                    </Typography>
                  </Box>
                 {navigationState === "common-portal" && <Box
                    sx={{
                      backgroundColor: "#fecb03",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      padding: { xs: "8px", sm: "14px", md: "10px" },
                      borderRadius: "10px",
                      flex: "0 0 auto",
                      height: { xs: "50px", sm: "80px", md: "60px" },
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer",
                      },
                      "&:active": {
                        transform: "translateY(0px)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                    onClick={switchToAttendance}
                  >
                    <Tooltip title="Switch to Face Attendance">
                      <SyncAltIcon
                        sx={{ fontSize: { xs: "20px", sm: "36px", md: "30px" } }}
                      />
                    </Tooltip>
                  </Box>}
                </Box>
                {/* ///  not required, since the Entry/Exit will be from physical entry device */}
                {/* <Box className="visitors-button-group">
                  <Box
                    sx={{
                      backgroundColor: "#fecb03",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      padding: { xs: "10px", sm: "15px", md: "10px" },
                      borderRadius: "10px",
                      width: { xs: "200px", sm: "460px", md: "260px" },
                      height: { xs: "50px", sm: "90px", md: "55px" },
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer",
                      },
                      "&:active": {
                        transform: "translateY(0px)",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                    onClick={handleQRInOut}
                  >
                    <QrCodeIcon
                      sx={{ fontSize: { xs: "20px", sm: "36px", md: "30px" } }}
                    />
                    <Typography
                      variant="button"
                      sx={{
                        fontSize: { xs: "14px", sm: "24px", md: "20px" },
                        fontWeight: "bold",
                      }}
                    >
                      In-Out
                    </Typography>
                  </Box>
                </Box> */}
              </Box>
              <Box className="visitors-image-container">
                <img
                  src={visitorImage}
                  alt="Visitors Management"
                  className="visitors-image"
                />
              </Box>
            </>
          )}

        {isCameraActive && !capturedImage && (
          <Box className="ribbon-bg-box">
            {!checkOutSuccess && (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "600px",
                  margin: "auto",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    margin: "auto",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <Box sx={{ position: "absolute", top: "1px", right: "20px" }}>
                    <IconButton edge="start" onClick={() => handleReset()}>
                      <CloseIcon
                        sx={{
                          fontSize: 32,
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: { xs: "350px", sm: "510px", md: "410px" },
                      height: { xs: "350px", sm: "510px", md: "410px" },
                      borderRadius: "50%",
                      padding: "5px",
                      background:
                        "linear-gradient(107.54deg, #F3F6FF 0.57%, #F2F6FF 46.35%, #DEE9FF 100%)",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      marginBottom: { xs: "2rem", sm: "2rem", md: "1rem" },
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <Webcam
                      ref={webcamRef}
                      audio={false}
                      screenshotFormat="image/jpeg"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    {isLoading &&
                      (mode === "Check In" || mode === "Check Out") && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            zIndex: 2,
                            transform: "translate(-50%, -50%)",
                            background: "rgba(255,255,255,0.4)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 350,
                            height: 350,
                          }}
                        >
                          <CircularProgress
                            sx={{ color: "#a5adbc" }}
                            size={280}
                            thickness={1}
                            disableShrink
                          />
                        </Box>
                      )}
                  </Box>
                  {mode === "Check Out" && (
                    <Box
                      sx={{
                        fontSize: "20px",
                        backgroundColor: "#fecb03",
                        padding: "10px",
                        borderRadius: "8px",
                        textAlign: "center",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                        animation: "popup 1s infinite",
                      }}
                    >
                      {faceRecogMessage}
                    </Box>
                  )}
                  {mode === "Check In" && (
                    <>
                    {visitorTypePopup?.type === "Guest" && (
                        <Typography
                          variant="body1"
                          sx={{ mb: 1, color: "#333" }}
                        >
                          Welcome <Box component="span" sx={{ fontWeight: "bold", display: "inline" }}>{visitorFormData?.name}</Box>! Please take a selfie to continue.
                        </Typography>
                    )}
                    <Box
                      sx={{
                        backgroundColor: isLoading ? "#ab8b0e" : "#fecb03",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                        padding: { xs: "10px", sm: "15px", md: "10px" },
                        borderRadius: "10px",
                        width: { xs: "200px", sm: "360px", md: "260px" },
                        height: { xs: "50px", sm: "90px", md: "55px" },
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        "&:hover": {
                          transform: isLoading ? "none" : "translateY(2px)",
                          boxShadow: isLoading
                            ? "none"
                            : "0px 8px 15px rgba(0, 0, 0, 0.2)",
                          cursor: isLoading ? "not-allowed" : "pointer",
                        },
                        "&:active": {
                          transform: isLoading ? "none" : "translateY(0px)",
                          boxShadow: isLoading
                            ? "none"
                            : "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        },
                        position: "relative",
                      }}
                      onClick={!isLoading ? captureImage : undefined}
                    >
                      {isLoading && (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "10px",
                            backgroundColor: "rgba(0, 0, 0, 0.15)",
                            zIndex: 1,
                          }}
                        />
                      )}
                      <CameraAltIcon
                        sx={{
                          fontSize: { xs: "22px", sm: "40px", md: "30px" },
                          zIndex: 2,
                        }}
                      />
                      <Typography
                        variant="button"
                        sx={{
                          fontSize: { xs: "12px", sm: "25px", md: "20px" },
                          fontWeight: "bold",
                          zIndex: 2,
                        }}
                      >
                        Capture Image
                      </Typography>
                    </Box>
                    </>
                  )}
                </motion.div>
              </Box>
            )}
            {checkOutSuccess && (
              <SuccessVisitorDialog
                checkOutInfo={checkOutInfo}
                checkOutVisitorImage={checkOutVisitorImage}
                user={user}
                mode={mode}
                handleClose={() => {
                  setIsCameraActive(false);
                  setMode(null);
                  setCheckOutSuccess(false);
                }}
              />
            )}
          </Box>
        )}
        {!checkOutSecondOption &&
          !isCameraActive &&
          !capturedImage &&
          checkOutSuccess && (
            <Box className="ribbon-bg-box">
              <SuccessVisitorDialog
                checkOutInfo={checkOutInfo}
                checkOutVisitorImage={checkOutVisitorImage}
                user={user}
                mode={mode}
                handleClose={() => {
                  setIsCameraActive(false);
                  setMode(null);
                  setCheckOutSuccess(false);
                }}
              />
            </Box>
          )}
        {checkOutSecondOption && (
          <Box className="ribbon-bg-box">
            <Box
              sx={{
                width: "100%",
                maxWidth: "500px",
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexWrap="wrap"
                gap={0.5}
                marginTop={"-50px"}
                position={"relative"}
              >
                <Box
                  sx={{
                    width: "1px",
                    position: "absolute",
                    left: "-15px",
                    top: "-10px",
                  }}
                >
                  <IconButton edge="start" onClick={() => handleReset()}>
                    <ArrowBackButton />
                  </IconButton>
                </Box>
                <Typography variant="h5" component="span">
                  Retry checkout with facial recognition
                </Typography>
                <Box
                  component="span"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "inherit",
                    margin: "0 4px",
                  }}
                >
                  <Icon
                    onClick={() => {
                      handleReset();
                      handleModeSelection("Check Out");
                    }}
                    sx={{
                      fontSize: "28px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                      backgroundColor: "#fecb03",
                      borderRadius: "50%",
                    }}
                  >
                    loop
                  </Icon>
                </Box>
                <Typography variant="h5" component="span">
                  or enter phone number
                </Typography>
              </Box>

              <TextField
                label="Enter Phone Number"
                placeholder="9876543210"
                variant="standard"
                type="number"
                fullWidth
                value={visitorCheckOutNumber}
                onChange={(e) => {
                  if (e.target.value.length <= 10) {
                    setVisitorCheckOutNumber(e.target.value);
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "28px",
                    height: "50px",
                    marginBottom: "20px",
                    "&:before": {
                      borderBottom: "2px solid #000",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid #1976d2",
                    },
                  },
                }}
                sx={{
                  "& .MuiInput-root": {
                    fontSize: "28px",
                    height: "50px",
                    borderBottom: "2px solid black",
                    "&:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid blue",
                    },
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "2px solid #1976d2",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "26px",
                  },
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  onClick={() =>
                    !visitorLoading && markCheckOut("second-option")
                  }
                  disabled={!isValidPhoneNumber(visitorCheckOutNumber)}
                  variant="contained"
                  sx={{
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    backgroundColor: "#fecb03",
                    minWidth: "unset",
                    "&:hover": {
                      backgroundColor: "#fecb03",
                    },
                  }}
                >
                  {visitorLoading ? (
                    <CircularProgress size={28} sx={{ color: "black" }} />
                  ) : (
                    <CheckIcon sx={{ fontSize: "32px", color: "black" }} />
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
        {capturedImage && (
          <Box className="ribbon-bg-box">
            {!checkInSuccess && (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "600px",
                  margin: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TypeformReplica
                  employeesData={employeesData}
                  handleEmployees={handleEmployees}
                  handleVisitorReasons={handleVisitorReasons}
                  visitorReasonData={visitorReasonData}
                  mode={mode}
                  visitorFormData={visitorFormData}
                  setVisitorFormData={setVisitorFormData}
                  setCheckInSuccess={setCheckInSuccess}
                  domain={Domain}
                  userId={user_id}
                  region_fk={regionFk}
                  isSingleOrg={isSingleOrg}
                  visitorOrgData={visitorOrgData}
                  handleOrg={handleOrg}
                  handleReset={handleResetForm}
                  visitorTypePopup={visitorTypePopup}
                  whatsAppFlow={isWhatsappFlow}
                />
              </Box>
            )}
            {checkInSuccess && (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "auto",
                }}
              >
                <img
                  src={thnxImg}
                  alt="Loading..."
                  width={"250px"}
                  height={"250px"}
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                  }}
                />
                <Typography
                  sx={{ pt: 1, pb: 1, textAlign: "center" }}
                  variant="h5"
                >
                  {`Registration is completed Welcome to ${Company}`}
                </Typography>
              </Box>
            )}
          </Box>
        )}
        {/* ////////  QR Mode ////// */}
        {qrMode && (
          <Box
            className="ribbon-bg-box"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box position={"relative"}>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Scan QR Code
              </Typography>
              <Box sx={{ position: "absolute", top: "-7px", right: "-62px" }}>
                <IconButton edge="start" onClick={handleReset}>
                  <CloseIcon
                    sx={{
                      fontSize: 32,
                    }}
                  />
                </IconButton>
              </Box>

            </Box>

            {/* Scanner Box */}
            <Box
              sx={{
                width: "300px",
                height: "300px",
                border: "3px dashed #8b44ff",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#faf7ff",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Camera Switch Icon */}
              <IconButton
                onClick={() =>
                  setCameraFacing((prev) =>
                    prev === "environment" ? "user" : "environment"
                  )
                }
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  background: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  "&:hover": {
                    background: "rgba(0,0,0,0.7)",
                  },
                  zIndex: 2,
                }}
              >
                <FlipCameraAndroidIcon size={"small"}/>
              </IconButton>

              {/* Scanner */}
              <div id="qr-reader" style={{ width: "100%" }}></div>

              {isLoading && (
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(255,255,255,0.75)",
                    zIndex: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    sx={{ color: "#a5adbc" }}
                    size={80}
                  />
                </Box>
              )}
            </Box>

            <Typography variant="body2" color="text.secondary">
              Align QR code inside the frame
            </Typography>
          </Box>
        )}
      </Box>
      <ToastContainer position="bottom-left" autoClose={2000} />
    </>
  );
};

export default VisitorManagement;
